var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.6667 30.3333C23.7668 30.3333 30.3333 23.7668 30.3333 15.6667C30.3333 7.56649 23.7668 1 15.6667 1C7.56649 1 1 7.56649 1 15.6667C1 23.7668 7.56649 30.3333 15.6667 30.3333Z","stroke":"#444444","strokeMiterlimit":"10","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M15.6665 7.66602V15.666H23.6665","stroke":"#444444","strokeMiterlimit":"10","strokeLinecap":"square","key":1})]);
}

Clock.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
